export default "__VITE_ASSET__DqdFUXGo__"